export default {
  jobSearch: {
    id: "job-search",
    name: "Job Search",
    path: "job-search",
  },
  other: {
    id: "other",
    name: "Other",
    path: "other",
  },
};
